import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const SynergyApiRoleIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3 9H21"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.0647 16.6402H9.97778L9.52856 15.2241L9.0647 16.6402ZM9.11108 14.4014H9.96069L11.2351 18H10.4197L10.1877 17.2603H8.86206L8.61304 18H7.8269L9.11108 14.4014Z"
                fill={props.htmlColor || '#21272E'}
            />
            <path
                d="M13.7205 15.5464C13.7205 15.3592 13.6708 15.2258 13.5715 15.146C13.4739 15.0663 13.3363 15.0264 13.1589 15.0264H12.4583V16.086H13.1589C13.3363 16.086 13.4739 16.0428 13.5715 15.9566C13.6708 15.8703 13.7205 15.7336 13.7205 15.5464ZM14.4651 15.5415C14.4651 15.9663 14.3577 16.2666 14.1428 16.4424C13.928 16.6182 13.6212 16.7061 13.2224 16.7061H12.4583V18H11.7112V14.4014H13.2786C13.6399 14.4014 13.928 14.4942 14.1428 14.6797C14.3577 14.8652 14.4651 15.1525 14.4651 15.5415Z"
                fill={props.htmlColor || '#21272E'}
            />
            <path d="M15.7175 18H14.9705V14.4014H15.7175V18Z" fill={props.htmlColor || '#21272E'} />
        </SvgIcon>
    );
};
